import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["name", "Raison sociale", "sm:col-span-2"], ["email", "Email de facturation", "sm:col-span-2"],
  ["line1", "Adresse", "sm:col-span-2"], ["line2", "Complément d'adresse", "sm:col-span-2"],
  ["postal_code", "Code postal", ""], ["city", "Ville", ""],
  ["country", "Pays (code, ex. FR, BE)", ""], ["vat", "N° TVA intracommunautaire", ""],
];

export const BillingDetails = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/billing/details").then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/billing/details", d);
      setD(data);
      toast.success("Coordonnées de facturation enregistrées");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <section className="rounded-lg border border-slate-200 p-6" data-testid="billing-details">
      <h2 className="font-semibold mb-1">Coordonnées de facturation</h2>
      <p className="text-sm text-slate-500 mb-5">Elles apparaissent sur vos factures. Les modifications s'appliquent aux prochaines factures.</p>
      {!d ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : (
        <form onSubmit={save} className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map(([k, label, span]) => (
            <label key={k} className={`block ${span}`}>
              <span className="text-xs text-slate-500">{label}{["line2", "vat"].includes(k) ? " (facultatif)" : ""}</span>
              <Input className="mt-1" type={k === "email" ? "email" : "text"} value={d[k] || ""} onChange={(e) => setD({ ...d, [k]: e.target.value })}
                required={!["line2", "vat"].includes(k)} maxLength={k === "country" ? 2 : 200} data-testid={`billing-details-${k}`} />
            </label>
          ))}
          <div className="sm:col-span-2">
            <Button type="submit" disabled={busy} data-testid="billing-details-save">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Enregistrer</Button>
          </div>
        </form>
      )}
    </section>
  );
};
